import React from "react";
import { Clock, CheckCircle2, XCircle } from "lucide-react";
import { Badge } from "../ui/badge";

export const getStatusBadge = (status, t) => {
  const statusConfig = {
    pending:  { variant: "outline",     icon: Clock,         labelKey: "planning.overridesPanel.statuses.pending" },
    approved: { variant: "default",     icon: CheckCircle2,  labelKey: "planning.overridesPanel.statuses.approved" },
    rejected: { variant: "destructive", icon: XCircle,       labelKey: "planning.overridesPanel.statuses.rejected" },
  };
  const config = statusConfig[status] || statusConfig.pending;
  const Icon = config.icon;
  return (
    <Badge variant={config.variant} className="gap-1">
      <Icon className="h-3 w-3" />
      {t(config.labelKey)}
    </Badge>
  );
};

export const getPriorityBadge = (priority, t) => {
  const priorityConfig = {
    1:  { color: "bg-muted text-muted-foreground",    labelKey: "planning.overridesPanel.priorities.low" },
    5:  { color: "bg-yellow-950/30 text-yellow-400", labelKey: "planning.overridesPanel.priorities.medium" },
    10: { color: "bg-orange-950/30 text-orange-400", labelKey: "planning.overridesPanel.priorities.high" },
  };
  const config = priorityConfig[priority] || priorityConfig[5];
  return <Badge className={config.color}>{t(config.labelKey)}</Badge>;
};

export const formatOverrideDate = (dateStr, locale = "fr") =>
  new Intl.DateTimeFormat(locale, { weekday: "long", year: "numeric", month: "long", day: "numeric" }).format(new Date(dateStr));
